import { useState, useEffect } from 'react';
import './index.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AcceptInvite from './pages/AcceptInvite';
import API_URL from './config';

const inviteToken = new URLSearchParams(window.location.search).get('invite');
const devBypass = process.env.REACT_APP_DEV_BYPASS === 'true';

export default function App() {
  const [session, setSession] = useState(() => {
    try {
      const s = localStorage.getItem('biz_session');
      return s ? JSON.parse(s) : null;
    } catch { return null; }
  });

  const handleLogin = (token, user) => {
    const s = { token, user };
    localStorage.setItem('biz_session', JSON.stringify(s));
    setSession(s);
  };

  useEffect(() => {
    if (!devBypass || session) return;
    fetch(`${API_URL}/api/dev/bypass`)
      .then(r => r.json())
      .then(d => handleLogin(d.business.token, d.business))
      .catch(() => {});
  }, [session]);

  const handleLogout = () => {
    localStorage.removeItem('biz_session');
    setSession(null);
  };

  if (inviteToken) return <AcceptInvite inviteToken={inviteToken} onAccepted={handleLogin} />;
  if (!session) return <Login onLogin={handleLogin} />;
  return <Dashboard token={session.token} user={session.user} onLogout={handleLogout} />;
}
